import { BasketRemoveIcon } from './BasketRemoveIcon';

/**
 * author: Michael Irigoyen
 * id C730C431-5377-4B0E-933B-5307E736B75A
 * name basket-remove
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basket-remove.svg
 * tags
 * - Shopping 
 */
export const ShoppingBasketRemoveIcon = BasketRemoveIcon;
export default ShoppingBasketRemoveIcon